import { BaseSkin } from '../base/index';
import { buttonOverrides } from '../default/buttonOverrides';
import { bigPlayButtonCss } from '../default/bigPlayButton';

export class DefaultSkin extends BaseSkin {
    constructor(...args) {
        super(...args);
        this.className = 'vjs-default-skin';
    }

    get styleOverrideContents() {
        const { colors, buttons } = this.props.skinProps;

        if (!colors) {
            return '';
        }

        return `
            .video-js {
                ${colors.text ? 'color: ' + colors.text : '' }
            }

            .video-js .vjs-control-bar {
                ${colors.background ? 'background-color: ' + colors.background : '' }
            }

            .video-js .vjs-slider {
                ${colors.progressbar ? 'background-color: ' + colors.progressbar : '' }
            }
            ` + buttonOverrides(buttons) + bigPlayButtonCss;
    }
}
